import { get } from "lodash";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import MessageComponent from "../../../components/message";
import { useHotspots } from "../../../context/hotspots";
import { useMessages } from "../../../context/messages";
import { formatHotspotName } from "../../../utils/hotspotUtils";
import { Message } from "../../../utils/types";

interface Props extends RouteComponentProps {}

const HotspotMessagesTab: React.FC<Props> = () => {
  const { currentHotspot } = useHotspots();
  const { messages } = useMessages();

  if (!currentHotspot) return null;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
      <div className="mt-6 pb-5">
        <p className="mt-2 max-w-4xl text-sm text-gray-500 dark:text-gray-300">
          Below you can see the messages sent to{" "}
          {formatHotspotName(currentHotspot)} because you verified its wallet.
          We do not reveal your identity in the process. The sender's Discord
          handle can be copied so you can connect.
        </p>
      </div>

      {get(messages, currentHotspot.id, []).map((message: Message) => (
        <div className="py-4" key={message.uuid}>
          <MessageComponent message={message} withDiscordHandle />
        </div>
      ))}
    </div>
  );
};

export default HotspotMessagesTab;
